import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { ASSETS_BY_IDS_QUERY } from 'personalization-lib/api/queries/assetQueries';
const useFetchAssetsByIds = (source, ids = [], onError) => {
  const sortedIds = useMemo(() => [...ids].sort(), [ids]);
  const {
    data,
    previousData,
    loading,
    error,
    refetch
  } = useQuery(ASSETS_BY_IDS_QUERY, {
    variables: {
      source: source,
      ids: sortedIds
    },
    skip: !source || !sortedIds.length,
    onError
  });
  const assetsById = (data === null || data === void 0 ? void 0 : data.assetsById) || (previousData === null || previousData === void 0 ? void 0 : previousData.assetsById);
  return useMemo(() => ({
    assetsById,
    loading,
    error,
    refetch
  }), [assetsById, loading, error, refetch]);
};
export default useFetchAssetsByIds;